module.exports = {
  LOCAL: 'local',
  OAUTH: 'oauth',
  AGCO_CUSTOMER_PORTAL: 'agco-customer-portal',
  AGCO_DEALER_PORTAL: 'agco-dealer-portal',
};
